/**
 * 表示中のページ数と、ページあたりに表示する求人件数から、
 * 表示中の求人件数の範囲（最初と最後の件数）を返す
 * @param {number} jobCount 求人数
 * @param {number} currentPage 表示中のページ数
 * @param {number} displayJobCountPerPage 1ページあたりに表示する求人数
 * @returns { first: number; last: number } 表示中の求人件数の範囲（最初と最後の件数） 例 2ページ目の場合、{ 26, 50 }
 */
export const getJobCountRange = (
  jobCount: number,
  currentPage: number,
  displayJobCountPerPage: number
): { first: number; last: number } => {
  const first = displayJobCountPerPage * (currentPage - 1) + 1;
  let last = displayJobCountPerPage * currentPage;

  // jobCountがdisplayJobCountPerPageの倍数じゃないときの考慮
  if (last > jobCount) {
    last = jobCount;
  }

  return { first, last };
};
